/**
 * VTHO network fee disposals (receipt-derived gas / gas-abstraction).
 * Aggregation is UI-only — exports always keep individual rows.
 */

export const VTHO_GAS_FEE_CLASSES = new Set([
  "gas_fee",
  "gas_abstraction_fee",
]);

export function isVthoGasFeeRow(row = {}) {
  const cls = String(
    row.classification ||
    row.type ||
    row.cls ||
    ""
  )
    .trim()
    .toLowerCase();

  const token = String(
    row.token ||
    row.asset ||
    "VTHO"
  )
    .trim()
    .toUpperCase();

  return token === "VTHO" && VTHO_GAS_FEE_CLASSES.has(cls);
}

export function finiteMoneyOrNull(value) {
  if (
    value === null ||
    value === undefined ||
    value === ""
  ) {
    return null;
  }

  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}
